import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/companies/$companySlug/applications/$applicationId')(
  {
    component: () => <Outlet />,
  },
)
